import { render, staticRenderFns } from "./dialogNewsDetail.vue?vue&type=template&id=054c91ed&scoped=true"
import script from "./dialogNewsDetail.vue?vue&type=script&lang=js"
export * from "./dialogNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogNewsDetail.vue?vue&type=style&index=0&id=054c91ed&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c91ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054c91ed')) {
      api.createRecord('054c91ed', component.options)
    } else {
      api.reload('054c91ed', component.options)
    }
    module.hot.accept("./dialogNewsDetail.vue?vue&type=template&id=054c91ed&scoped=true", function () {
      api.rerender('054c91ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/dialogNewsDetail.vue"
export default component.exports